import React from 'react';
import { MemoryRouter, Routes, Route } from 'react-router-dom';
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';

const TEST_TEAM = { uuid: 't-1', name: 'Test Team', role: 'Admin' };
const TEST_CREDITS = { credits: 90, setCredits: () => {} };
const TEST_SIDEBAR = { isOpen: false, toggle: () => {} };

// Stable i18n for tests — inline resources, no HTTP fetches, t(key) returns key.
// Prevents useCallback([projectUuid, t]) from creating a new loadX fn every render
// when the real i18n singleton finishes its async translation fetch mid-test.
// NOTE: do NOT call .use(initReactI18next) here — that calls setI18n() which
// overwrites the global i18n singleton used by the real app, breaking translations
// for all non-test pages. I18nextProvider passes the instance via React context
// directly, so initReactI18next is not needed inside a Provider tree.
const testI18n = i18next.createInstance();
testI18n.init({
  resources: { en: { translation: {} }, pt: { translation: {} } },
  lng: 'en',
  fallbackLng: 'en',
  ns: ['translation'],
  defaultNS: 'translation',
  interpolation: { escapeValue: false },
  initImmediate: false,
});

function TeamsContextProvider({ children }) {
  try {
    const { TeamsContext } = require('../Components/ContextProviders/TeamsContextProvider');
    return (
      <TeamsContext.Provider value={{ currentTeam: TEST_TEAM, teams: [TEST_TEAM], switchToTeam: () => {}, updateTeams: () => {}, updateTeamInList: () => {}, clearTeamData: () => {}, setCurrentTeam: () => {}, setTeams: () => {} }}>
        {children}
      </TeamsContext.Provider>
    );
  } catch (e) {
    return <>{children}</>;
  }
}

function CreditsContextProvider({ children }) {
  try {
    const { CreditsContext } = require('../Components/ContextProviders/CreditsContextProvider');
    return (
      <CreditsContext.Provider value={TEST_CREDITS}>
        {children}
      </CreditsContext.Provider>
    );
  } catch (e) {
    return <>{children}</>;
  }
}

function SidebarProvider({ children }) {
  try {
    const { SidebarProvider: RealProvider } = require('../Components/ContextProviders/SidebarContextProvider');
    return <RealProvider>{children}</RealProvider>;
  } catch (e) {
    return <>{children}</>;
  }
}

export function TestWrapper({ children, initialPath = '/' }) {
  return (
    <I18nextProvider i18n={testI18n}>
      <MemoryRouter initialEntries={[initialPath]}>
        <SidebarProvider>
          <TeamsContextProvider>
            <CreditsContextProvider>
              <Routes>
                <Route path="/project/:project_uuid/flow" element={children} />
                <Route path="/project/:project_uuid/*" element={children} />
                <Route path="*" element={children} />
              </Routes>
            </CreditsContextProvider>
          </TeamsContextProvider>
        </SidebarProvider>
      </MemoryRouter>
    </I18nextProvider>
  );
}

export function withWrapper(component, initialPath = '/') {
  return <TestWrapper initialPath={initialPath}>{component}</TestWrapper>;
}
